var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60039 10.3441L3.36839 10.5761C3.1669 10.7791 2.87247 10.8591 2.596 10.786C2.31952 10.713 2.10301 10.498 2.02803 10.2221C1.95304 9.94612 2.03097 9.65112 2.23245 9.44821L9.44804 2.23262C9.76005 1.92246 10.264 1.92246 10.576 2.23262L17.7676 9.44821C18.079 9.76189 18.0772 10.2687 17.7636 10.5801C17.4499 10.8916 16.9431 10.8898 16.6316 10.5761L16.3997 10.3436V17.1994C16.3997 17.6412 16.0415 17.9993 15.5997 17.9993H12.3999C11.9581 17.9993 11.5999 17.6412 11.5999 17.1994V13.9996C11.5999 13.5578 11.2418 13.1996 10.8 13.1996H9.20007C8.75827 13.1996 8.40012 13.5578 8.40012 13.9996V17.1994C8.40012 17.6412 8.04196 17.9993 7.60016 17.9993H4.40034C3.95854 17.9993 3.60039 17.6412 3.60039 17.1994V10.3441ZM11.5999 9.19985C11.5999 10.0835 10.8836 10.7998 10 10.7998C9.11642 10.7998 8.40012 10.0835 8.40012 9.19985C8.40012 8.31625 9.11642 7.59994 10 7.59994C10.8836 7.59994 11.5999 8.31625 11.5999 9.19985Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepot);
export default __webpack_public_path__ + "static/media/depot.78937cc02ca2f348aca744ed51a76423.svg";
export { ForwardRef as ReactComponent };